export default __webpack_public_path__ + "static/tertiary-2-97f16d72c0a9e279393dd86a5999a4e4.jpg";